module.exports = __webpack_public_path__ + "img/Web.68f3e505.png";